
<template>
	<div class="search-text">
		<div class="readState" v-if="resInfoState == 'ready'">
			<SvgIcon :name="getLoadingName()" size="16" class="loading-img"/>
			<!-- <img :src="loadingSvg" class="loading-img" /> -->
		  <div class="ready-text">{{ $t('chat.role.ready') }}<span class="dot-ani"></span></div>
		</div>
		<div v-if="resInfos">
			<w-collapse class="collapseBox" :class="{finishedBox:!loading&&!chatStore.isSensitive}" :style="{ 'width': getWidth}" :expand-icon-position="'right'"  v-if="resInfoState == 'running'||resInfoState=='finish'" :bordered="false" expand-icon-position="left">
				<w-collapse-item v-if="resInfos" key="1">
					<template #header>
							<div v-if="!loading&&!chatStore.isSensitive"><SvgIcon class='icon-chazhao' name="cool-chazhao"/>{{$t('chat.center.onLineSearchTitle',{name: resInfos.length,num: resInfoNum})}}</div>
							<div v-else class="loading-icon">
								<SvgIcon :name="getLoadingName()" size="16" class="loading-img"/>
								<!-- <img :src="loadingSvg" class="loading-img"/> -->
								{{resInfoState=='finish'?t('chat.role.finish'):currentTitle  }}
								<span :class="[!loading&&!chatStore.isSensitive?'':'dot-ani']"></span>
							</div>
					</template>
					<template #expand-icon="{ active }">
							<w-popover placement="rt" trigger="hover" :show-arrow="false" content-class="rounded-lg border-none p-0 w-50 arrowIcon">
								<SvgIcon class="arricon" :name="`cool-${active ? 'ArrowUpSLineWe': 'ArrowDownSLineWe'}`" size="14" color="#646479"/>
								<template #content>
									{{!active?$t('chat.role.arrow1'):$t('chat.role.arrow2')  }}
								</template>
							</w-popover>
						</template>
					<div class="online" :class="[isMobile?'online-mobile':'online-pc']">
						<div v-for="(items,indexs) in resInfos" :key="indexs" :class="[isMobile?'online-item':'']">	
							<!-- {{ resInfoState }}0000{{ items.state }}1111 -->
							<div class="child-title" :class="[isMobile?'title-mobile':'title-pc']">
								<!-- <w-spin :size="12" v-if="items.state != 'finish'"/> -->
								<SvgIcon size="12" :name="`cool-${items.type == 'WEB' ? 'lianwang1': 'zhishiku'}`"/>
								<span class="name">{{ items.type == 'WEB' ? $t('chat.center.bingSearch') : $t('chat.center.fileSearch') }}{{ items.plan }}</span>					
							</div>
							<div v-if="items.type == 'WEB'"  class="child-list" :class="[isMobile?'list-mobile':'list-pc']">
								<div class="line" :class="[getResultLineState(items)?'lineLong':'lineShort']"></div>
								<div v-if="items.resInfo&&items.state!='ready'" class="search_wrap" >
									<div v-for="(item,index) in items.resInfo" :key="index" :class="[isMobile?'mobileProcess':'process']" @click="gotoDetail(item)"  v-show="items.state!='finish'||!loading&&!chatStore.isSensitive">
										<div class="process-title-wrap">
										<div class="process-title">
											<span v-if="item.no" class="index">{{item.no}}</span>
											<span>{{item.title}}</span>
										</div>
									</div>
									<div class="process-url">
											<img v-if="getSourceType(item.url) == '知乎'" :src="zhihuIcon" alt="">
											<img v-else-if="getSourceType(item.url) == '百度'" :src="baiduIcon" alt="">
											<img v-else-if="getSourceType(item.url) == '今日头条'" :src="toutiaoIcon" alt="">
											<img v-else :src="defaultIcon" alt="">
											<span>{{ getSourceType(item.url) }}</span>
									</div>
								</div>
								</div>	
								<div v-else-if="!items.resInfo&&(items.state=='running'||items.state=='ready')&&resInfoState != 'finish'"  class="search_wrap">
									<div v-for="(item,index) in 3" :key="index" class="process loading-box">
										<w-skeleton :animation="true">
											<w-space class='loading'>
												<w-skeleton-shape class="left" />
												<w-space class="right" direction="vertical" size="default" >
                        <w-skeleton-line  :rows="1" />
												<w-skeleton-shape class="right-box" />
												<div class="right-bottom">
													<w-skeleton-shape class="left" />
												  <w-skeleton-shape class="bottom-box" />
												</div>
											</w-space>
										</w-space>
									</w-skeleton>
									</div>
								</div>
							</div>
							<div v-else class="search_wrap" >
								<div v-for="(item,index) in items.resInfo" :key="index" :class="[isMobile?'mobileProcess':'process']"  @click="gotoDetail(item)">
									<div class="docShowBox">
										<span class="iconDiv" :class="`${item.type}File`">
											<CoolDocx v-if="item.type== 'doc' || item.type== 'docx'" size="20" />
											<CoolPdf v-else-if="item.type== 'pdf'" size="20" />
											<CoolTxt v-else-if="item.type== 'txt'" size="20" />
											<CoolLianjie v-else-if="item.type== 'url'" size="20" />
											<CoolMarkdownB50n94pc v-else-if="item.type== 'md'" size="20" />
										</span>
										<div><p>{{ item.title }}</p>
											<p v-if="item.wordCount">{{ t('chat.addRole.about') + item.wordCount + t('chat.addRole.text') }}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="search_finish" v-if="resInfoState == 'finish'">
							<CoolZongjie  size="12" v-if="resInfos" />
							<span>{{ resInfos[0].type == 'WEB' ? $t('chat.center.pageSummary'): $t('chat.center.pageKBSummary') }}</span>
						</div>
					</div>
				</w-collapse-item>
			</w-collapse>
		</div>
	</div>
</template>
<script lang="ts" setup>
import { computed,watch,ref } from 'vue';
import { useI18n } from 'vue-i18n';
import loadingSvg from "/@common/assets/chat/loading.svg"
import baiduIcon from '/@common/assets/chat/source/baidu.svg';
import zhihuIcon from '/@common/assets/chat/source/zhihu.svg';
import { useChatStore } from '/@/stores/chat';
import toutiaoIcon from '/@common/assets/chat/source/toutiao.svg';
import defaultIcon from '/@common/assets/chat/source/default.svg';
import progressBar from "./progressBar.vue" 
import { useBasicLayout } from '/@common/hooks/useBasicLayout';
const { isMobile } = useBasicLayout();
const { t } = useI18n();
const currentName=ref(t('chat.role.lineCheck'))
const titleList = ref([])
const titleCurrent=ref(0)
const container = ref(null);
const timer=ref(null)
const chatStore = useChatStore()
const currentNum=ref(0)
const currentNames=ref([])
interface Props {
	resInfoState?: string;
	resInfos?:[],
	loading?:boolean,
	from?:string,
	width?:number
}
const props = defineProps<Props>();
const getWidth=computed(()=>{
	if(isMobile.value){
		return 'calc(100vw - 52px)'
	}else{
		return props.from?`${props.width}px`:`${chatStore.centerMaxWidth - 130}px`
	}
	})
const gotoDetail = (item) => {
	window.open(item.url, '_blank');
}
const getLoadingName=()=>{
	return localStorage.getItem('winbox-theme')?'cool-jiazai-hong': 'cool-jiazai2'
}
const getResultLineState=(item:object)=>{//true 长 false短
	if(!props.loading&&!chatStore.isSensitive){//回答结束了
		return item?.resInfo&& item.resInfo?.length?true:false
	}else{
		if(props.resInfoState=='finish'){
			return false
		}else{
			return item.state=='running'||item.state=='ready'?true:false
		}
	}
}
const currentTitle=computed(()=>{
	if(props.resInfos?.length&&props.resInfoState=='running'){
		let find=props.resInfos.filter(item=>item.searching)
		if(find.length){
			if(!currentNames.value.includes(find[0].plan)){
				currentNames.value.push(find[0].plan)
				currentNum.value+=1
			}
			
			return `${t('chat.center.name',{num:currentNum.value})}${find[0].plan}${t('chat.center.loadingStatus')}`
		}
		return `${t('chat.role.running')}`
	}
})
watch(
  () => props.resInfos,
  (value) => {
		if(value?.length){
			let arr=[]
			value.forEach((item,i)=>{
				if(item.resInfo?.length){
					arr.push(...item.resInfo)
				}
			})
			if(arr.length ){
					titleList.value=arr
			}

		}
		
	},{deep:true})
	watch(() => titleList.value, (val,oldvalue) => {
		if(val){
			// updateTitle(titleCurrent.value,val)
		}
	})
	watch(() => props.resInfoState, (val,oldvalue) => {
		if(val=='finish'){
			currentNum.value=0
			currentNames.value=[]
		}
	})
	const updateTitle=(index:number,list:Array<object>)=>{
		// clearTimeout(timer.value)
		// timer.value=setTimeout(()=>{
			if(index<=list.length){
					console.log('update',index,list);
			const item = list[index]||{};
			if(item?.title){
					currentName.value=t('chat.role.lineCheck')+item.title
				  titleCurrent.value+=1
			}
		}
		// },0)		
	}
const resInfoNum = computed(() => {
	let num = 0
	props.resInfos?.forEach((item) => {
		item.active=true
		item.currentProgress=10
		num += item.resInfo ? item.resInfo.length: 0
	})
	return num
})
const currentStatus=computed(()=>{
	const typleList={
		running:t('chat.role.running'),
		finish:t('chat.role.finish')
	}
	return typleList[props.resInfoState]
})
const resInfoName= computed(() => {
	let name = ""
	props.resInfos?.forEach((item) => {
		num += item.resInfo.plan ? item.resInfo.plan: 0
	})
	return name
})
const getSourceType = (url) => {
  if (!url) return ''
  if (url.includes('www.zhihu.com')) {
    return '知乎'
  } else if (url.includes('www.baidu.com')) {
    return '百度'
  } else if (url.includes('www.toutiao.com')) {
    return '今日头条'
  }else{
	return url
  }
}
</script>

<style lang="scss">
.search-text{
	.readState{
		min-width: 860px;
		display: flex;
		align-items: center;
		background: var(--stages-bg);
		border-radius: 8px;
		padding-left: 8px;
		.ready-text{
			padding:2px 0;
			// color:#646479;
			color:#181B49;
			margin-left: 3px;
			font-size: var(--font14);
			font-weight: bold;
		}
	}
	.online{
		background: var(--stages-bg);
		padding: 4px 12px;
		border-radius: 8px;
		.online-item{
			// width:fit-content;
		}
		.child-title{
			font-weight: 400;
			font-size: var(--font12);
			color: #181B49;
			text-align: left;
			font-style: normal;
			display: flex;
			align-items: center;
			margin: 5px;
			margin-left: 0;
		
			.cool-icon{
				margin-right: 3px
			}
			.w-spin{
				margin-right: 5px;
			}
			.name{
				white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
			}
		}
		.title-mobile{
			max-width:730px;
		}
		.child-list{
			display:flex;
			.line{
				width:1px;
				margin:-5px 10px 2px 6px;
				background-color: #E4E8EE;
			}
			.lineLong{
				min-height: 89px;
			}
			.lineShort{
				height: 13px;
			}
		}
		.list-mobile{
			max-width:730px;
		}
		.w-steps-item-process .w-steps-icon {
			background-color: transparent;
		}
		.w-steps-icon {
			// width:0px !important;
		}
		.w-steps-item-title {
			font-weight: 400;
    font-size: var(--font12);
    color: #181B49;
		left:-16px;
		}
		.w-progress-line{
			transform: rotate(90deg);
		}
		.search_finish{
			font-weight: 400;
			font-size: var(--font12);
			color: #181B49;
			// padding-left: 5px;
			.cool-icon{
				margin-right: 3px
			}
		}

	}
	.online-mobile{
		width:100%;
		overflow-x:auto;
	}
	.search_wrap{
		width: calc(100% - 21px);
		display: -webkit-box;
		display: -webkit-flex;
		display: -moz-box;
		display: flex;
		-webkit-flex-wrap: wrap;
		flex-wrap: wrap;
		.w-skeleton-shape{
			// width:50% !important;
			// height: 20px !important;
		}
		.process{
			width: calc(33% - 21px);
			flex: 0 0 calc(33% - 21px);
			padding: 12px;
			border-radius: 6px;
			background: #fff;
			box-sizing: border-box;
			cursor: pointer;
			margin-right: 8px;
			margin-bottom: 10px;
			.docShowBox{
				display: flex;
				align-items: center;
				justify-content: flex-start;
				.iconDiv{
					display: inline-block;
					width: 32px;
					height: 32px;
					margin-right: 10px;
					flex-shrink: 0;
					display: flex;
					align-items: center;
					justify-content: center;
					border-radius: 8px;
				}
				.pdfFile{
					background: rgba(245,80,96,0.1);
				}
				.txtFile{
					background: RGBA(16, 219, 215, 0.1);
				}
				.mdFile{
					background: RGBA(82, 204, 240, 0.1);
				}
				.docFile,.docx{
					background: RGBA(60, 102, 255, 0.1)
				}
				.urlFile{
					background: RGBA(128, 132, 255, 0.1);
				}
				>div{
					overflow: hidden;
					width: 330px;
					p:nth-child(1){
						font-size: var(--font12);
						font-weight: 400;
						color: #3D485D;
						line-height: 18px;
						margin-bottom: 4px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
					p:nth-child(2){
						font-size: var(--font12);
						font-weight: 400;
						color: #C6C6D2;
						line-height: 16px;
					}
				}
				
			}
		}
		.mobileProcess{
			// width: calc(33% - 21px);
			// flex: 0 0 calc(33% - 21px);
			// min-width:150px;
		  width:230px;
			padding: 12px;
			border-radius: 6px;
			background: #fff;
			box-sizing: border-box;
			cursor: pointer;
			margin-right: 5px;
			margin-bottom: 10px;
			overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
			.docShowBox{
				display: flex;
				align-items: center;
				justify-content: flex-start;
				.iconDiv{
					display: inline-block;
					width: 32px;
					height: 32px;
					margin-right: 10px;
					flex-shrink: 0;
					display: flex;
					align-items: center;
					justify-content: center;
					border-radius: 8px;
				}
				.pdfFile{
					background: rgba(245,80,96,0.1);
				}
				.txtFile{
					background: RGBA(16, 219, 215, 0.1);
				}
				.mdFile{
					background: RGBA(82, 204, 240, 0.1);
				}
				.docFile,.docx{
					background: RGBA(60, 102, 255, 0.1)
				}
				.urlFile{
					background: RGBA(128, 132, 255, 0.1);
				}
				>div{
					overflow: hidden;
					width: 330px;
					p:nth-child(1){
						font-size: var(--font12);
						font-weight: 400;
						color: #3D485D;
						line-height: 18px;
						margin-bottom: 4px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
					p:nth-child(2){
						font-size: var(--font12);
						font-weight: 400;
						color: #C6C6D2;
						line-height: 16px;
					}
				}
				
			}
		}
		.loading-box{
			min-width:246px;
			height: 86px;
			.loading{
				 width:100%;
				 height: 100%;
         border-radius: 8px;
         display:flex;
				 .w-skeleton-line-row{
					height: 12px !important;
				}
				.left{ 
					width:12px;
          height:12px;
          border-radius:50%;
				}
				.right{
					width:212px;
          height:12px;
					.right-box{
						width:190px;
						height:12px;
					}
					.right-bottom{
						display: flex;
						.bottom-box{
						width:50px;
					  height:12px;
					  margin-left: 5px;
					}
				}	
			 }
			}
		}
		.process:nth-child(3n+0){
			margin-right: 0px;
		}

		.process-title-wrap{
			display: flex;
			align-items: center;
			margin-bottom: 8px;
			.index{
				width: 14px;
				height: 14px;
				background: #E4E8EE;
				display: inline-block;
				line-height: 14px;
				text-align: center;
				border-radius:4px;
				margin-right: 3px;
			}
		}
		.process-title{
			color: #1a2029;
			font-size: var(--font12);
			font-style: normal;
			font-weight: 400;
			line-height: 18px;
			width: 100%;
			white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis; 
		}
		.process-url{
			width:100%;
			color: #b0b7c0;
			font-size: var(--font12);
			font-style: normal;
			font-weight: 400;
			line-height: 12px;
			display: flex;
			align-items: center;
		
			img{
				width: 14px;
				margin-right: 3px;
			}
			>span{
				overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
			}
		}

	}
	.collapseBox{
		// min-width: 400px;
		// min-width: 900px;
		width:100%;
		white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
		.titleInfo{
			.w-spin{
			position:absolute;
			top:25px;

		}
		}

		:deep(.w-tooltip-content){
			color:rgb(100, 100, 121) !important;
		}
		.loading-icon{
			display:flex;
			align-items:center;
		}
		.icon-chazhao{
			// position:absolute;
			// z-index: 1;
			// top:21px;
			// left:24px;
			margin-right:5px;
		}
  .arricon{
		position: absolute;
		left: 0px;
		top:-8px;

}
		.w-collapse-item-header-title{
			font-weight: bold;
			margin-left: 18px;
		}
		.w-collapse-item-active > .w-collapse-item-header{
			border: none;
			background-color: transparent;
			background: var(--stages-bg);
			height: 32px;
			border-radius: 8px;
		}
		.w-collapse-item-header{
			border: none;
			background-color: transparent;
			// background: var(--stages-bg);
			height: 32px;
			border-radius: 8px;
			left:-12px;
		}
		.w-icon-hover:hover::before{
			background: transparent !important;
		}
		.w-collapse-item-content{
			background-color: transparent;
			padding-left: 0;
		}
		.w-collapse-item-content-box{
			line-height: 2;
		}
		.w-collapse-item-header-left{
			padding-left:0;
			padding: 0;
		}
		.w-collapse-item-header-right + .w-collapse-item-content{
			padding-left: 0
		}
		.w-collapse-item-header-left{
			padding-left: 24px;
		}
		.w-collapse-item .w-collapse-item-icon-hover{
			// left: 315px;
		}
		.w-collapse-item .w-collapse-item-icon-right {
    right: 22px;
}
.w-collapse-item-header-right{
	padding-left:0px;
}
		.referenceItem{
			color: #355EFF;
			cursor: pointer;
		}
		.w-collapse-item-header-title {
			width:100%;
			color:#181B49;
			font-size: var(--font14);
			overflow: hidden;
			white-space: nowrap;
	    text-overflow: ellipsis;
			// font-weight: 500;
			>div{
				width:100%;
			  overflow: hidden;
			  white-space: nowrap;
	      text-overflow: ellipsis;
			}
		}
	}
	.finishedBox{
		.w-collapse-item-active > .w-collapse-item-header{
			background-color: transparent;
		}
		.w-collapse-item-header{
			width:calc(100% + 20px);
			background-color: transparent;
			left:-17px;
		}
		// .w-collapse-item-header
	}
}
.arrowIcon{

    .w-popover-content{
        padding: 5px!important;
        // text-align: center!important;
    }


}
.arrowIcon.w-popover-popup-content{
        min-width: 35px!important;
}
.icon-loading{
	display:flex;
}
.dot-ani {
      display: inline-block;
      height: 16px;
      line-height: 16px;
      overflow: hidden;
			margin-top:-6px;
    }
    .dot-ani::after {
			font-size: 20px;
      display: inline-table;
      white-space: pre;
      content: "\A.\A..\A...\A....\A.....\A......";
      animation: spin 2s steps(7) infinite;
    }
    @keyframes spin {
      to{
        -webkit-transform:translateY(-112px);
        transform:translateY(-112px)
      }
    }
		@keyframes spinImg {
  0% {
    transform: rotate(0deg); 
  }
  100% {
    transform: rotate(360deg); 
  }
}
		.loading-img{
			display: flex;
			align-items: center;
			justify-content: center;
			margin-right:3px;
			transform-origin: center center;
            animation: spinImg 1s linear infinite;
            will-change: transform; 
		}
</style>
